export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/onboard/admin/login/",
    FORGOT_PASSWORD_OTP: "/onboard/admin/forgot_password_otp/",
    REFRESH_TOKEN: "/onboard/admin/refresh_token/",
    FORGOT_PASSWORD_OTP_VERIFY: "/onboard/admin/forgot_password_otp_verify/",
    FORGOT_PASSWORD_TOKEN: (() => {
      const basePath = "/onboard/admin/forgot_password_token/";
      return {
        BASE: basePath,
        Token: (token: string) => {
          const path = `${basePath}${token}/`;
          return {
            BASE: path,
          };
        },
      };
    })(),

  },

  API: {
    PRODUCT: (() => {
      const basePath = "/core/product/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        FILTER_PRODUCT_PRICE_LIST: (contactId: string) => {
          return `${basePath}filter_price_list/?contact=${contactId}`;
        },
      };
    })(),
    SUPPORT_TICKET: (() => {
      const basePath = "/onboard/tenant/admin_support_ticket/";
      return {
        BASE: basePath,
      };
    })(),
    SUPPORT_PHONE: (() => {
      const basePath = "/onboard/admin/admin_support_contact_info/";
      return {
        BASE: basePath,
      };
    })(),
    PARTNER_CATEGORY: (() => {
      const basePath = "/onboard/partner/partner_category/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    TENANT_SUBSCRIPTION: (() => {
      const basePath = "/onboard/tenant/subscription/";
      return {
        BASE: basePath,
        MESSAGE_CREDIT_CONFIG: "/onboard/tenant/message-credit-config/",
        EXTEND_SUBSCRIPTION: (id: string) => `${basePath}${id}/extend_subscription/`,
        HISTORY: (id: string) => `${basePath}${id}/history/`,
      };
    })(),
    TENANT_TRANSACTION: (() => {
      const basePath = "/onboard/tenant/transaction/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        GST_RETURN_EXPORT: "/user/gst-return-export/",
      };
    })(),
    RUN_PAYOUT: (() => {
      const basePath = "/onboard/partner/partner_payout/";
      const tiar = "onboard/admin/commission_summary/"
      return {
        BASE: basePath,
        TIER: tiar,
        EXPORT: `${basePath}export_excel/`,
        PAY_NOW: `${basePath}pay_now/`
      };
    })(),
    PAYOUT_LOG: (() => {
      const basePath = "/onboard/admin/partner_payout_log/";
      return {
        BASE: basePath,
        EXPORT: `${basePath}export_excel/`,
      };
    })(),
    PARTNER_PENDING_PAYOUT: (() => {
      const basePath = "/onboard/partner/pending_commission_earning/";
      return {
        BASE: basePath,
        PENDING_DETAILS: (partnerId: string) => `${basePath}${partnerId}/earnings/`
      };
    })(),
    PARTNER: (() => {
      const basePath = "/onboard/partner/profile/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        TARGET: (id: string) => `${basePath}${id}/partner_target/`,
        REVENUE_PAYMENTS: (id: string) => {
          return {
            BASE: `${basePath}${id}/payout_history/`,
            KPIS: `${basePath}${id}/payout_history_kpis/`
          }
        },
        TIER_COUNTS: `${basePath}tier_partner_counts/`,
        STATUS_CLARIFICATION: `/onboard/partner/status_clarification/`,
        INVITATION_STATUS: (id: string) => {
          return {
            BASE: `${basePath}${id}/invitation_status/`
          }
        },
        SUSPENTION_REVOKE: (id: string) => {
          return {
            BASE: `${basePath}${id}/admin_suspension_management/`
          }
        }
      };
    })(),
    TENANT_USER: (() => {
      const basePath = "/onboard/tenant_user/";
      return {
        BASE: basePath,
      };
    })(),
    ADMIN_PERMISSION: (() => {
      const basePath = "/onboard/admin/admin-permissions/";
      return {
        BASE: basePath,
      };
    })(),
    SYSTEM_STATUS: (() => {
      const basePath = "/onboard/admin/admin-permissions/";
      return {
        BASE: basePath,
        WEBSOCKET_URL: (id: string, token: string) =>
          `${import.meta.env.VITE_SOCKET_URL
          }ws/system_update/${id}/?token=${token}`,
      };
    })(),
    ROLE_PERMISSIONS: (() => {
      const basePath = "/onboard/admin/admin-role-permissions/";
      return {
        BASE: basePath,
        BULK_DELETE: `${basePath}delete_multiple/`,
        CREATE: `/onboard/admin/admin-permissions/fetch_all/`,
        FETCH_ALL: `${basePath}fetch_all/`,
        FETCH_ALL_PERMISSIONS: "/onboard/admin/admin-role-permissions/",
      };
    })(),
    ADMIN_PARTNER: (() => {
      const basePath = "/onboard/admin/partner_tenant/";
      return {
        MAPPED_USER: (id: string) => `${basePath}?partner_id=${id}`,
        EXPORT: (id: string) => `${basePath}export_excel/?partner_id=${id}`,
        PROFILE: (id: string, partner_id: string) => `${basePath}${id}/?partner_id=${partner_id}`,

      };
    })(),
    USER: (() => {
      const basePath = "/onboard/admin/profile/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    USER_ACTIVITY: (() => {
      const basePath = "/core/admin/activity-log/";
      return {
        BASE: basePath,
        FETCH_ALL: basePath,
      };
    })(),
    GLOBAL_COUNTRY: (() => {
      const basePath = "/onboard/tenant/country/fetch_all/";
      return {
        BASE: basePath,
      };
    })(),
    GLOBAL_STATE: (() => {
      const basePath = "/onboard/tenant/state/fetch_all/";
      return {
        BASE: basePath,
      };
    })(),
    GLOBAL_CITY: (() => {
      const basePath = "/onboard/tenant/city/fetch_all/";
      return {
        BASE: basePath,
      };
    })(),
    CATEGORY: (() => {
      const basePath = "/core/category/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    TIER: (() => {
      const basePath = "/core/tenant/tier/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    COMMISSION_RULE: (() => {
      const basePath = "/core/admin/commission_rule/";
      return {
        BASE: basePath,
        ACTIVE_COMMISION_RULE: `${basePath}active/`
      };
    })(),
    COMMISSION_RULES: (() => {
      const basePath = "/core/admin/commission_rule/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        DUPLICATE: `${basePath}duplicate/`,
        GET_PENDING_UPGRADE: `${basePath}pending_upgrade/`
      };
    })(),
    TARGET: (() => {
      const basePath = "/core/admin/target/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        DUPLICATE: `${basePath}duplicate/`,
      };
    })(),
    PARTNER_CATEGORIES: (() => {
      const basePath = "/onboard/partner/partner_category/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    DASHBOARD: (() => {
      const basePath = "/onboard/admin/admin_portal/";
      return {
        BASE: basePath,
      };
    })(),
    PARTNER_PERFORMANCE: (() => {
      const basePath = "/onboard/admin/performance-wise-partners/";
      return {
        BASE: basePath,
      };
    })(),
    MESSAGE_CREDIT_CONFIG: (() => {
      const basePath = "/onboard/tenant/message-credit-config/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
        CURRENCY_FETCH_ALL: "/core/admin/currency/fetch_all/",
      };
    })(),
    COUPON: (() => {
      const basePath = "/onboard/admin/coupon/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    PAYMENT_LINK: (() => {
      const basePath = "/onboard/admin/payment_link/";
      return {
        BASE: basePath,
        SYNC: (id: string) => `${basePath}${id}/sync/`,
        CANCEL: (id: string) => `${basePath}${id}/cancel/`,
      };
    })(),
    COUPON_USAGE: (() => {
      const basePath = "/onboard/tenant/coupon-usage/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    OFFLINE_REGISTRATION: (() => {
      const basePath = "/onboard/admin/offline-register/";
      return {
        BASE: basePath,
      };
    })(),
    TENANT_VERIFY_GST: (() => {
      const basePath = "/onboard/tenant/tenant_verify_gst/";
      return {
        BASE: basePath,
      };
    })(),
    MODEL_WISE_CONFIGURATION: (() => {
      const basePath = "/core/admin/llm_price_config/";
      return {
        BASE: basePath,
      };
    })(),
    WHATSAPP_MESSAGE_PRICE: (() => {
      const basePath = "/onboard/admin/whatsapp_template_price_config/";
      return {
        BASE: basePath,
      };
    })(),
    EMAIL_CREDITS_PRICE_CONFIGURATION: (() => {
      const basePath = "/onboard/admin/email_credits_price_configuration/";
      return {
        BASE: basePath,
      };
    })(),

    STORAGE_PRICE_CONFIGURATION: (() => {
      const basePath = "/onboard/admin/storage_price_configuration/";
      return {
        BASE: basePath,
      };
    })(),
    GOOGLE_ADS_MARGIN_CONFIGURATION: (() => {
      const basePath = "/onboard/admin/google_ads_margin_configuration/";
      return {
        BASE: basePath,
      };
    })(),
    GUEST_PLAN: (() => {
      const basePath = "/onboard/tenant/guest-plan/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    PLAN: (() => {
      const basePath = "/onboard/admin/plan/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    TAX: (() => {
      const basePath = "/onboard/tenant/tax/";
      return {
        BASE: basePath,
      };
    })(),
    TIMEZONE: (() => {
      const basePath = "/onboard/tenant/timezone/";
      return {
        BASE: basePath,
        FETCH_ALL: `${basePath}fetch_all/`,
      };
    })(),
    CHECKUNIQNESS: (() => {
      const basePath = "/user/check-uniqueness/";
      return {
        BASE: basePath,
      };
    })(),
    ADMIN_TENANT: (() => {
      const basePath = "/onboard/admin/tenant/";
      return {
        BASE: basePath,
        DETAIL: (id: string) => `${basePath}${id}/`,
        IMPERSONATE: "/onboard/admin/tenant_impersonation_login/",
      };
    })(),
    IMPERSONATION_ACTIVITY_LOG: (() => {
      const basePath = "/core/admin/impersonation_activity_log/";
      return {
        BASE: basePath,
      };
    })(),
  },
};
